<div class="container">
    <div class="row">
        <div class="col-sm-12 title">
            <h1 class="main-heading">{{ 'rpe.vista-muestreador.title' | translate }}</h1>
        </div>
    </div>
    <div class="row">
        <rpe-entity-muestreador-form-container></rpe-entity-muestreador-form-container>
    </div>
</div>
